import { TServerDefectivesStore } from '@monorepo/types';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { ServerDefectivesStoreActionTypes, TServerDefectivesActions } from './server-defectives-db.action';

export function getServerDefectivesInitialState(nextCacheResetTimestamp: number) {
  const serverDefectivesInitialState: TServerDefectivesStore = {
    lockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    serverDefectivesDB: {
      dailyCache: {
        hasInitialized: false,
        nextCacheResetTimestamp: nextCacheResetTimestamp,
        lineWiseServerDefectives: {},
        lastSyncTime: 0,
      },
    },
  };
  return serverDefectivesInitialState;
}
export const serverDefectivesInitialState: TServerDefectivesStore =
  getServerDefectivesInitialState(INITIAL_CACHE_RESET_TIMESTAMP);

export function ServerDefectivesStoreStateReducer(
  state: TServerDefectivesStore = serverDefectivesInitialState,
  action: TServerDefectivesActions,
): TServerDefectivesStore {
  switch (action.type) {
    case ServerDefectivesStoreActionTypes.UpdateServerDefectivesStoreLockDetails: {
      return produce(state, (draft) => {
        draft.lockDetails = action.lockDetails;
      });
    }
    case ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenEmitForServerImagesBackFill:
    case ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenDismissLoader:
    case ServerDefectivesStoreActionTypes.SetServerDefectivesDBAndReleaseLockAndThenInitMasterdataListAndClientDB: {
      return produce(state, (draft) => {
        draft.serverDefectivesDB = action.serverDefectivesDB;
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case ServerDefectivesStoreActionTypes.ReleaseLockAndThenShowErrorAndThenDismissLoader:
    case ServerDefectivesStoreActionTypes.ReleaseLock: {
      return produce(state, (draft) => {
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    default:
      return state;
  }
}
